import { j as r } from "../../modules/index.es3.js";
import * as i from "react";
import { cn as l } from "../../utils/styling.es.js";
import { spinnerVariants as m } from "./Spinner.styles.es.js";
const f = i.forwardRef(({ size: e, appearance: s, className: t, children: o, ...a }, c) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    className: "flex items-center justify-center text-left space-x-1 max-w-[14rem]",
    ref: c,
    ...a,
    children: [
      /* @__PURE__ */ r.jsxs(
        "svg",
        {
          className: l(m({ appearance: s, size: e, className: t })),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ r.jsx(
              "circle",
              {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
              }
            ),
            /* @__PURE__ */ r.jsx(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ),
      o
    ]
  }
));
export {
  f as default
};
//# sourceMappingURL=Spinner.es.js.map
